import { FormSettingsEnum } from "@dev/ee-api/ee-api-models";
import { includes } from "lodash-es";

export const isSetNotifyEmails = (formSettings: Array<FormSettingsEnum>) => includes(formSettings, FormSettingsEnum.NotifyEmails);